export default __webpack_public_path__ + "static/media/level2.65ef1d09.png";